import { Component, Prop } from 'vue-property-decorator';
import BaseBlock from '@/blocks/base-block';
import { Block } from '../../../helpers/components';
import { ApartmentDTO } from '../../../model/ApartmentDTO';
import { FloorAbbrForTooltip } from '../../../enums/FloorAbbrForTooltip'

@Block() @Component
class ApartmentHeadingBlock extends BaseBlock {
	@Prop() apartment: ApartmentDTO;

	get city() {
		var result = this.apartment.location.city;
		if (this.apartment.location.cityPart) {
			result += " - " + this.apartment.location.cityPart;
		}

		return result;
	}
	
	get showBreadcrumbs() {
		return !(this.$route.query.predbezne && this.$route.query.csh);
	}


	//get bannerHtml() {
	//	return this.getText('banner').trim();
	//}

	showTooltipFloor(floorAbbr: string) {
		return (<any>Object).values(FloorAbbrForTooltip).includes(floorAbbr);
	}
}

export default ApartmentHeadingBlock;
